import React from 'react';

const Facebook = (props: React.PropsWithChildren<React.SVGProps<SVGSVGElement>>) => (
  <svg
    {...props}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    role="img"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.90455 3.99219H11V2.08438C10.8114 2.05859 10.1614 2 9.40455 2C7.825 2 6.74318 2.99375 6.74318 4.81953V6.5H5V8.63281H6.74318V14H8.87955V8.63281H10.5523L10.8182 6.5H8.87955V5.03047C8.87955 4.41406 9.04545 3.99219 9.90455 3.99219Z"
      fill="currentColor"
    />
  </svg>
);

export default Facebook;
